import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    DataTableSearchDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    container: {
        flexShrink: 1
    }
});

export const useStyles = ({
    shapeConfigs,
    isFlexible
}: DataTableSearchDynamicStyleType) => {
    const styles = {
        container: (isFlexible ? {
            flexGrow: 1,
            minWidth: 0
        } : {
            width: shapeConfigs.sideListWidth
        }) as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
